import { API_ENDPOINTS } from '@utils/endpoints';
import { BaseService } from '../baseService';
import { CreateAccountPayload, AccountResponse } from '@models/User';

export class createAccountService {
  /**
   * @function register
   * @param payload user registration data
   * @returns AccountResponse
   */
  static register = async (payload: CreateAccountPayload): Promise<AccountResponse> => {
    const response = await BaseService.post(API_ENDPOINTS.REGISTER, payload);
    return response as AccountResponse;
  };

  /**
   * @function getUserDetails
   * @returns AccountResponse
   */
  static getUserDetails = async (): Promise<AccountResponse> => {
    const response = await BaseService.get(API_ENDPOINTS.USER);
    return response as AccountResponse;
  };
}
